import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import DatePicker from 'react-datepicker';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-datepicker/dist/react-datepicker.css';

const roomData = {
  'Ocean View Suite': {
    name: 'Ocean View Suite',
    images: ['/assets/ocean-view-1.jpg', '/assets/ocean-view-2.jpg'],
    description: 'Spacious suite with private balcony and Atlantic views.',
    features: ['1 King bed', 'Balcony', 'Wi-Fi', 'Private Bathroom'],
    price: '$120 / night',
    priceValue: 12000,
    unavailableDates: ['2025-06-10', '2025-06-12', '2025-06-15'],
  },
};

function RoomDetail() {
  const { roomName } = useParams();
  const decodedRoomName = decodeURIComponent(roomName);
  const room = roomData[decodedRoomName];
  const [selectedDate, setSelectedDate] = useState(null);

  if (!room) return <div className="p-10 text-center">Room not found.</div>;

  const unavailableDates = room.unavailableDates.map(date => new Date(date));

  return (
    <div className="p-10 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">{room.name}</h1>

      <Carousel showThumbs={false} infiniteLoop autoPlay>
        {room.images.map((src, i) => (
          <div key={i}>
            <img src={src} alt={`${room.name} ${i + 1}`} />
          </div>
        ))}
      </Carousel>

      <p className="mt-4">{room.description}</p>
      <ul className="list-disc list-inside text-gray-700 mt-4 mb-4">
        {room.features.map((feature, i) => (
          <li key={i}>{feature}</li>
        ))}
      </ul>
      <p className="text-xl font-bold mb-4">{room.price}</p>

      <div className="mb-6">
        <label className="block mb-2 font-semibold">Select your check-in date:</label>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          excludeDates={unavailableDates}
          minDate={new Date()}
          placeholderText="Select a date"
          className="border p-2 w-full"
        />
      </div>

      <Link
  to={`/booking?room=${encodeURIComponent(room.name)}&price=${room.priceValue}&date=${selectedDate ? encodeURIComponent(selectedDate.toISOString()) : ''}`}
  className="bg-blue-700 text-white px-6 py-2 rounded hover:bg-blue-800"
>
  Book This Room
</Link>

    </div>
  );
}

export default RoomDetail;
